/**
 * A Firestore time as an ISO string, whichever way it was written: the app
 * writes serverTimestamp() (a Timestamp), the live lessons server writes
 * ISO strings (store.ts postThreadMessage). Reading only Timestamps left
 * a thread's server-written lastMessageAt undefined, so the Messages list
 * showed the thread's creation date (audit 2 Nov, A16).
 */
export function isoOf(v: unknown): string | undefined {
  if (typeof v === 'string') return Number.isNaN(Date.parse(v)) ? undefined : v;
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? undefined : v.toISOString();
  const t = v as { toDate?: () => Date } | null | undefined;
  return typeof t?.toDate === 'function' ? t.toDate().toISOString() : undefined;
}

/** Newest message first: the Messages list's order, whichever way each time was written. */
export function byLastMessage<T extends { lastMessageAt?: string; createdAt?: string }>(a: T, b: T): number {
  return (b.lastMessageAt ?? b.createdAt ?? '').localeCompare(a.lastMessageAt ?? a.createdAt ?? '');
}
